module.exports = __webpack_public_path__ + "static/profile-75664e0b53435af2b5c949404ae18c0e.png";